import 'webmapsjs/dist/import-queryui';
import {quickMap} from 'webmapsjs/dist/olHelpers/quickMap';
import {makeServiceUrl, LayerEsriMapServer, LayerEsriMapServerOptions} from 'webmapsjs/dist/layers/LayerEsriMapServer';
import {LayerEsriTileOptions, LayerEsriTile} from 'webmapsjs/dist/layers/LayerEsriTile';
import React = require("react");
import ReactDom = require("react-dom");
import {Provider} from "react-redux";
import {connect} from "react-redux";
import {store, iState, getState} from './store';
import * as cnst from './constants';
import {Metric, TimePeriod, WeekLabel, WeekSlider} from './controls';
import TileArcGISRest from 'ol/source/TileArcGISRest';
import * as actions from './actions';
import {Legend} from "./legend";

function _getLayerIndex(s?: iState): number {
    if (!s) {
        s = getState();
    }

    let lyr_ind = cnst.times.indexOf(s.the_time);

    if (s.metric === cnst.metrics[0]){
        lyr_ind += 4
    }

    return lyr_ind
}


function updateLayerParams(s?: iState) {
    if (!s) {
        s = getState();
    }

    let lyr_ind = _getLayerIndex(s);

    let defsf = {
        layers: `show:${lyr_ind}`,
        layerDefs: `{"${lyr_ind}":"week=${s.week + 1}"}`
    };

    (cnst.covidLyr.olLayer.getSource() as TileArcGISRest).updateParams(defsf);
}

function updateLegend(s?: iState, counter=0) {
    if (!s) {
        s = getState();
    }
    counter++;

    if (counter > 20){
        return;
    }

    if (cnst.legend['layers']){
        let ind = _getLayerIndex(s);

        let legendInfo = cnst.legend['layers'][ind]['legend'];

        // console.log(cnst.legend['layers'][ind]['legend']);
        if (legendInfo != s.legend){
            store.dispatch({type: actions.ACTION_CHANGE_LEGEND, legend: legendInfo} as actions.iChangeLegend);
        }
    } else {
        setTimeout(() => {
            updateLegend(s, counter);
        }, 200);
    }

}


store.subscribe(() => {
    let s = getState();


    updateLayerParams(s);
    updateLegend(s);


    console.log(s);
});

class _App extends React.Component<{}, {}> {

    componentDidMount() {

        let map = quickMap({});

        map.addLayer(cnst.covidLyr.olLayer);

        updateLayerParams();
        updateLegend();

    }


    render() {
        return <div id="app-container">
            <div id="map">

                {/*<Controls/>*/}
                <div id="controls">
                    <Metric/>
                    <TimePeriod/>
                    <WeekLabel/>
                    <WeekSlider/>
                    <Legend/>
                    <p style={{maxWidth: '175px'}}>Weekday and Rush values are from Thursdays of a given week
                        and Weekend value is from Saturday of a given week</p>
                </div>

            </div>
        </div>

    }
}

const
    App = connect(
        (s: iState) => {
            return {};
        },
        (dispatch) => {
            return {};
        })(_App);


ReactDom.render(
    <Provider store={store}><App/></Provider>,
    document
        .getElementById(
            'root'
        ));

